module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-plus-773bfb03.svg";